import { TimelineLite } from 'gsap'
import 'classlist-polyfill'

export default function(animationContainer) {
    let tl = new TimelineLite({
        paused: true,
        onComplete: () => tl.restart()
    });

    const delay = 0.2;
    const triangles = document.querySelectorAll('.octonica-logo__triangle');

    const path = [0, 1, 2, 3, 2, 4, 5, 6, 7, 6, 5, 4, 2, 1];

    for (let i = 0; i < path.length; i++) {
        let ti = path[i];
        let t = triangles[ti];
        tl.to(t, delay, {
            onComplete: function () {
                [].forEach.call(triangles, n => n.classList.remove('octonica-logo__triangle_highlight'));
                t.classList.add('octonica-logo__triangle_highlight');
            }
        });
    }

    const navbar = document.querySelector(animationContainer);
    navbar.addEventListener('mouseenter', () => tl.resume());
    navbar.addEventListener('mouseleave', () => tl.pause());
}